import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteOrganization as deleteOrganizationApi } from '../services/apiUsers.ts'
import { toast } from '../utils/sweetAlert.ts'

export function useDeleteOrganization() {
  const queryClient = useQueryClient()

  const { isLoading: isDeleting, mutate: deleteOrganization } = useMutation({
    mutationFn: deleteOrganizationApi,
    onSuccess: () => {
      queryClient.invalidateQueries(['organizations'])
      toast('success', `Organization has been successfully deleted!`)
    },
    onError: (error: any) => {
      toast('error', `Something went wrong! ${error.message}`)
    },
  })

  return { isDeleting, deleteOrganization }
}
